<template>
  <div>
    <BigHeader  title="Always up to date" subtitle="Follow the latest LISA news" icon1="" line1="" icon2=""  line2="" icon3=""  line3=""></BigHeader>

<div style="height:600px;"></div>
  </div>
</template>

<script>

  import BigHeader from '../components/BigHeader'

  export default {
    components: {
      BigHeader
    },
    data () {
      return {


      }
    }
  }
</script>
